export enum CampaignGoalType {
  InStoreSales = 'in_store_sales',
  ECommerceSales = 'ecommerce_sales',
  LeadGeneration = 'lead_generation',
  WebsiteSessions = 'website_sessions',
}
